export const RETURNS_SLUG = 'returns'
export const RETURNS_PATH = '/returns'

export const RETURNS_HTML = `<div class="sp-page">
  <h1 class="sp-title">Returns</h1>
  <div class="sp-intro">
    We understand sometimes your birth doesn't go as planned. We accept returns for most items as long as they are in new condition in their original and unopened packaging.
  </div>
  <h2 class="sp-heading">Return Policy</h2>
  <ul class="sp-list">
    <li><strong>All items can be returned within 90 days of the original ship date to qualify for a refund.</strong> Items returned after 90 days may not be refunded and will not be returned to the customer.</li>
    <li>We are not able to offer refunds for items returned which are opened, used, dirty, damaged or otherwise altered from their original condition.</li>
    <li>The following items are not returnable:
      <ul class="sp-list sp-list-nested">
        <li>Herbal Afterbirth Bath</li>
        <li>Soothing Herbal Bath</li>
        <li>Arkansas Midwife Sitz Bath, Karen Brock Herbal Bath, Eden Song Herbal Bath</li>
        <li>All breast pumps</li>
        <li>Dry herbs sold by the ounce</li>
        <li>Any special order item</li>
      </ul>
    </li>
    <li><strong>Any shipping cost originally paid is non-refundable.</strong></li>
    <li><strong>We are not able to offer free return shipping, the customer is responsible for the return shipping cost. The cost of any prepaid shipping label will be deducted from the refund amount.</strong></li>
    <li>All refunds will be issued back to the original payment method used for the order.</li>
    <li>The return refund is issued for the original purchase price of the item(s) returned, including any sales tax collected (if applicable).</li>
    <li>In His Hands is not responsible for returned items lost during transit.</li>
  </ul>
  <h2 class="sp-heading">Incorrect or defective items</h2>
  <p>If a wrong or defective item has been sent to you please <a href="/help-center">contact us</a> to arrange for a refund or replacement. You will not be responsible for any return shipping cost.</p>
  <h2 class="sp-heading">Start your return</h2>
  <h3 class="sp-subheading">Option 1 - UPS Return Label</h3>
  <div class="sp-cta-wrap">
    <a class="sp-button" href="https://track.shipstation.com/f/r/b/nMg3zA2kjOqh7o7bGNfbuQ%3D%3D" target="_blank" rel="noopener noreferrer">Get Label</a>
  </div>
  <p class="sp-note">The cost of the return label <em>($8-$30 depending on the size and weight of the package)</em> will be deducted from the refund.</p>
  <p>Having trouble generating a label? Please <a href="/help-center">contact us</a>. You can drop your return package at any <a href="https://www.ups.com/dropoff" target="_blank" rel="noopener noreferrer">UPS Dropoff</a> location.</p>
  <h3 class="sp-subheading">Option 2 - Provide your own label</h3>
  <p>Please send the items you are returning with the packing slip (or a photocopy of it) back to:</p>
  <address class="sp-address">
    In His Hands Birth Supply<br>
    Attention: RETURNS<br>
    P.O. Box 467 (USPS only)<br>
    OR<br>
    325 Cole Dr.<br>
    Liberty Hill, TX 78642
  </address>
  <p>Please allow 2-8 business days after we have received your return for it to be processed. You will receive an email with the details of your refund once it has been completed.</p>
  <p class="sp-disclaimer"><em>In His Hands reserves the right to refuse to refund an item at our own discretion. If you have questions about this policy, please <a href="/help-center">contact us</a>. Thank you!</em></p>
</div>`

export const RETURNS_CSS = `.static-page {
  color: #736980;
  font-size: 1rem;
  line-height: 1.75;
}
.static-page a {
  color: #e59789;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.static-page a:hover {
  color: #ffbeb2;
}
.static-page .sp-page {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.static-page .sp-title {
  margin: 0 0 2rem;
  color: #453c50;
  font-size: 1.875rem;
  font-weight: 600;
  text-align: center;
}
.static-page .sp-intro {
  margin: 0 auto;
  max-width: 100%;
  padding: 1rem;
  color: #736980;
  font-size: 1.125rem;
  font-style: italic;
  line-height: 2rem;
  text-align: center;
  border: 2px solid #e59789;
  border-radius: 1.5rem;
}
.static-page .sp-heading {
  margin: 1rem 0 0;
  padding: 1rem 0;
  color: #453c50;
  font-size: 1.5rem;
  font-weight: 600;
  text-align: left;
}
.static-page .sp-subheading {
  margin: 0;
  padding: 1rem 0 0;
  color: #453c50;
  font-size: 1.25rem;
  font-weight: 600;
}
.static-page .sp-list {
  margin: 0;
  padding-left: 1.5rem;
  list-style: disc;
}
.static-page .sp-list > li + li {
  margin-top: 0.5rem;
}
.static-page .sp-list-nested {
  margin-top: 0.25rem;
  list-style: disc;
}
.static-page .sp-list-nested > li + li {
  margin-top: 0.25rem;
}
.static-page .sp-cta-wrap {
  display: flex;
  justify-content: center;
  padding: 1rem 0;
}
.static-page .sp-button {
  display: inline-flex;
  width: 100%;
  max-width: 11rem;
  justify-content: center;
  padding: 0.75rem 1rem;
  color: #fff;
  font-size: 1.25rem;
  font-weight: 600;
  text-align: center;
  text-decoration: none;
  background: #e59789;
  border-radius: 9999px;
}
.static-page .sp-button:hover {
  color: #fff;
  opacity: 0.92;
}
.static-page .sp-note {
  color: #453c50;
  font-size: 1.125rem;
  font-weight: 600;
}
.static-page .sp-address {
  margin: 0;
  padding-left: 1rem;
  font-style: normal;
  font-weight: 600;
}
.static-page .sp-disclaimer {
  line-height: 2rem;
}
@media (min-width: 640px) {
  .static-page .sp-heading {
    font-size: 2.25rem;
  }
  .static-page .sp-subheading {
    font-size: 1.5rem;
  }
}`

export function returnsSeedDocument() {
	const now = new Date()
	return {
		slug: RETURNS_SLUG,
		path: RETURNS_PATH,
		title: 'Returns',
		metaTitle: 'Returns | In His Hands Birth Supply',
		status: 'published',
		draftHtml: RETURNS_HTML,
		draftCss: RETURNS_CSS,
		publishedHtml: RETURNS_HTML,
		publishedCss: RETURNS_CSS,
		publishedAt: now,
		publishedBy: '',
		chats: [],
		activeChatId: '',
		created: now,
		updated: now,
	}
}
